import { render, staticRenderFns } from "./FooterPdf.vue?vue&type=template&id=fb82506e&"
import script from "./FooterPdf.vue?vue&type=script&lang=js&"
export * from "./FooterPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports